// extracted by mini-css-extract-plugin
export default {"cf":"global__cf__oIYxa","pageTitles":"global__pageTitles__Zrjro"};